"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProductsViewQueryState = void 0;
const view_query_params_1 = require("../../../../../common/view-query-params");
const utils_1 = require("../../../../../hooks/product-table-dynamic-columns/utils");
const getProductsViewQueryState = ({ catalogId, dynamicColumns, filter, middleSectionFilter, pageSize, projectId, search, selectedTreeNodePath, sort, }) => ({
    [view_query_params_1.ViewQueryStateField.ProjectId]: projectId,
    [view_query_params_1.ViewQueryStateField.CatalogId]: catalogId,
    [view_query_params_1.ViewQueryStateField.Filter]: filter,
    [view_query_params_1.ViewQueryStateField.Search]: search,
    [view_query_params_1.ViewQueryStateField.Sort]: sort,
    [view_query_params_1.ViewQueryStateField.PageSize]: pageSize,
    [view_query_params_1.ViewQueryStateField.DynamicColumns]: (0, utils_1.compactDynamicColumnsForViewQueryState)(dynamicColumns),
    [view_query_params_1.ViewQueryStateField.MiddleSectionFilter]: middleSectionFilter,
    [view_query_params_1.ViewQueryStateField.SelectedTreeNodePath]: selectedTreeNodePath,
});
exports.getProductsViewQueryState = getProductsViewQueryState;
